import {
  Box,
  Checkbox as MuiCheckbox,
  type CheckboxProps as MuiCheckboxProps,
} from "@mui/material";

import { mergeSxProps } from "../../lib/mergeSxProps";
import { CbhIcon } from "../CbhIcon";

export type CheckboxProps = Pick<
  MuiCheckboxProps,
  "sx" | "checked" | "disabled" | "onChange" | "required"
>;

/**
 * A helper component to render the empty checkbox state
 * It is intentionally not exported from this file
 */
function EmptyCheckbox() {
  return (
    <Box
      sx={(theme) => ({
        width: theme.size?.checkbox?.width,
        height: theme.size?.checkbox?.height,
        borderRadius: "0.5rem",
        border: `1px solid ${theme.palette.border?.primary}`,
      })}
    />
  );
}

export function Checkbox(props: CheckboxProps) {
  const { sx, ...rest } = props;

  return (
    <MuiCheckbox
      {...rest}
      icon={<EmptyCheckbox />}
      checkedIcon={<CbhIcon type="checkmark" />}
      sx={mergeSxProps(
        (theme) => ({
          width: theme.size?.checkbox?.width,
          height: theme.size?.checkbox?.height,
          // theme.borderRadius.xSmall would be too large of a radius
          //   for the checkbox so we're using a non-theme value
          borderRadius: "0.5rem",
          padding: 0,
          "&.Mui-checked": {
            backgroundColor: theme.palette.primary.main,
          },
          "&.Mui-disabled": {
            backgroundColor: theme.palette.action?.disabled,
          },
          "&.Mui-checked .MuiSvgIcon-root": {
            color: theme.palette.icon?.lightInvert,
          },
        }),
        sx
      )}
    />
  );
}
